import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { selectClass } from './styles';
import { inputClass } from '../Input/styles';
import { inputTitleClass } from '../InputTitle/styles';
import { isObject, isFunc, isString, isEmpty, isNumber } from '../utils/is';
import { addResizeObserver } from '../utils/dom/element';
import Input from './Input';
import Caret from '../icons/Caret';
import { isRTL } from '../config';
import More, { getResetMore } from './More';
import InputTitle from '../InputTitle';
import { getDirectionClass } from '../utils/classname';
import ShallowEqual from '../utils/shallowEqual';
export var IS_NOT_MATCHED_VALUE = 'IS_NOT_MATCHED_VALUE';
/**
 * get result className from resultClassName attr
 * @param {function | string} f props => resultClassName
 * @param {any} value result value
 * @returns {string | null}
 */

var getResultClassName = function getResultClassName(f, data) {
  var unMatchedData = data;

  if (isFunc(f)) {
    return f(isObject(unMatchedData) && unMatchedData.IS_NOT_MATCHED_VALUE ? unMatchedData.value : unMatchedData);
  }

  if (isString(f)) {
    return f;
  }

  return null;
};

var getResultContent = function getResultContent(data, renderResult, renderUnmatched) {
  var unMatchedData = data;

  if (isObject(unMatchedData) && unMatchedData.IS_NOT_MATCHED_VALUE) {
    if (typeof renderUnmatched === 'function') return renderUnmatched(unMatchedData.value);
    return isObject(unMatchedData.value) ? renderResult(unMatchedData.value) : unMatchedData.value;
  }

  return renderResult(data);
}; // eslint-disable-next-line


function Item(_ref) {
  var isDisabled = _ref.isDisabled,
      onClick = _ref.onClick,
      resultClassName = _ref.resultClassName,
      value = _ref.value,
      getDataByValue = _ref.getDataByValue,
      getContent = _ref.getContent,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? false : _ref$title,
      only = _ref.only;
  var data = getDataByValue(value);
  if (data === null) return null;
  var content = getContent(data);
  var disabled = isDisabled(data);
  var click = disabled || !onClick ? undefined : function () {
    return onClick(data);
  };
  var synDisabled = disabled || !click;
  return (
    /*#__PURE__*/
    React.createElement("a", {
      title: title && isString(content) ? content : undefined,
      tabIndex: -1,
      className: classnames(selectClass(getDirectionClass('item'), disabled && getDirectionClass('disabled'), synDisabled && getDirectionClass('ban'), only && 'item-only'), getResultClassName(resultClassName, data))
    }, content, !synDisabled &&
    /*#__PURE__*/
    React.createElement("span", {
      className: selectClass('indicator', 'close'),
      onClick: click
    }))
  );
}

var Result =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Result, _PureComponent);

  var _super = _createSuper2(Result);

  function Result(props) {
    var _this;

    _classCallCheck(this, Result);

    _this = _super.call(this, props);
    _this.resultEl = void 0;
    _this.cancelResizeObserver = void 0;
    _this.shouldResetMore = void 0;
    _this.state = {
      more: -1
    };
    _this.handleRemove = _this.handleRemove.bind(_assertThisInitialized(_this));
    _this.handelMore = _this.handelMore.bind(_assertThisInitialized(_this));
    _this.bindResult = _this.bindResult.bind(_assertThisInitialized(_this));
    _this.resetMore = _this.resetMore.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Result, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var compressed = this.props.compressed;

      if (compressed && !this.isCompressedBound()) {
        this.cancelResizeObserver = addResizeObserver(this.resultEl, this.resetMore, {
          direction: 'x'
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(preProps) {
      this.updateMore(preProps);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.cancelResizeObserver) this.cancelResizeObserver();
    }
  }, {
    key: "getCompressedBound",
    value: function getCompressedBound() {
      var compressedBound = this.props.compressedBound;

      if (this.isCompressedBound()) {
        return compressedBound;
      }

      return this.state.more;
    }
  }, {
    key: "isCompressedBound",
    value: function isCompressedBound() {
      var compressedBound = this.props.compressedBound;
      return compressedBound && isNumber(compressedBound) && compressedBound >= 1;
    }
  }, {
    key: "bindResult",
    value: function bindResult(el) {
      this.resultEl = el;
    }
  }, {
    key: "updateMore",
    value: function updateMore(preProps) {
      var _this$props = this.props,
          compressed = _this$props.compressed,
          onFilter = _this$props.onFilter,
          values = _this$props.values,
          data = _this$props.data;

      if (compressed) {
        if (this.isCompressedBound()) return;
        var shouldRest = !ShallowEqual(preProps.values, values) || (data || []).length !== (preProps.data || []).length;

        if (shouldRest) {
          this.resetMore();
        } else if ((values || []).length && this.shouldResetMore) {
          this.shouldResetMore = false; // @ts-ignore

          this.state.more = getResetMore(onFilter, this.resultEl, this.resultEl.querySelectorAll(".".concat(selectClass('item'))));
          this.forceUpdate();
        }
      }
    }
  }, {
    key: "resetMore",
    value: function resetMore() {
      if (!this.props.compressed) return;
      this.shouldResetMore = true; // @ts-ignore

      this.state.more = -1;
      this.forceUpdate();
    }
  }, {
    key: "handleRemove",
    value: function handleRemove() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var onRemove = this.props.onRemove;
      setTimeout(function () {
        onRemove.apply(void 0, args);
      }, 10);
    }
  }, {
    key: "isEmptyResult",
    value: function isEmptyResult() {
      var _this$props2 = this.props,
          values = _this$props2.values,
          renderResult = _this$props2.renderResult,
          renderUnmatched = _this$props2.renderUnmatched,
          getResultByValue = _this$props2.getResultByValue;
      if (values.length <= 0) return true;
      var hasValue = values.findIndex(function (item) {
        var cur = getResultByValue(item);
        var r = getResultContent(cur, renderResult, renderUnmatched);
        return !isEmpty(r);
      }) >= 0;
      return !hasValue;
    }
  }, {
    key: "handelMore",
    value: function handelMore(more) {
      this.setState({
        more: more
      });
    }
  }, {
    key: "renderItem",
    value: function renderItem(value, index) {
      var _this$props3 = this.props,
          renderResult = _this$props3.renderResult,
          renderUnmatched = _this$props3.renderUnmatched,
          datum = _this$props3.datum,
          resultClassName = _this$props3.resultClassName,
          getResultByValue = _this$props3.getResultByValue;
      if (value === null) return null;
      var more = this.getCompressedBound();
      return (
        /*#__PURE__*/
        React.createElement(Item, {
          key: index,
          only: more === 1,
          value: value,
          getDataByValue: getResultByValue,
          getContent: function getContent(data) {
            return getResultContent(data, renderResult, renderUnmatched);
          },
          isDisabled: function isDisabled(data) {
            return datum.disabled(data);
          },
          onClick: this.handleRemove,
          resultClassName: resultClassName,
          title: true
        })
      );
    }
  }, {
    key: "renderMore",
    value: function renderMore(items) {
      var _this$props4 = this.props,
          compressedClassName = _this$props4.compressedClassName,
          compressed = _this$props4.compressed;
      var more = this.getCompressedBound();
      var className = classnames(selectClass('popover'), compressedClassName);
      return [
      /*#__PURE__*/
      React.createElement(More, {
        key: "more",
        showNum: more,
        className: selectClass(getDirectionClass('item'), 'item-compressed'),
        popoverClassName: className,
        contentClassName: selectClass(getDirectionClass('result')),
        compressed: compressed,
        data: items,
        more: more,
        cls: selectClass
      })];
    }
  }, {
    key: "renderClear",
    value: function renderClear() {
      var _this$props5 = this.props,
          onClear = _this$props5.onClear,
          disabled = _this$props5.disabled,
          values = _this$props5.values;

      if (onClear && values && values.length && disabled !== true) {
        /* eslint-disable */
        return (
          /*#__PURE__*/
          React.createElement("div", {
            key: "clear",
            onClick: onClear,
            className: selectClass('close-warpper')
          },
          /*#__PURE__*/
          React.createElement("a", {
            tabIndex: -1,
            "data-role": "close",
            className: selectClass('indicator', 'close')
          }))
        );
        /* eslint-enable */
      }

      return null;
    }
  }, {
    key: "renderInput",
    value: function renderInput(text) {
      var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'input';
      var _this$props6 = this.props,
          multiple = _this$props6.multiple,
          onFilter = _this$props6.onFilter,
          trim = _this$props6.trim,
          focus = _this$props6.focus,
          onInputFocus = _this$props6.onInputFocus,
          onInputBlur = _this$props6.onInputBlur,
          setInputReset = _this$props6.setInputReset,
          focusSelected = _this$props6.focusSelected,
          bindFocusInputFunc = _this$props6.bindFocusInputFunc,
          maxLength = _this$props6.maxLength,
          convertBr = _this$props6.convertBr;
      return (
        /*#__PURE__*/
        React.createElement(Input, {
          key: "".concat(key, ".").concat(focus ? 1 : 0),
          onInputFocus: onInputFocus,
          onInputBlur: onInputBlur,
          updatAble: !multiple,
          multiple: multiple,
          focus: focus,
          text: text,
          trim: trim,
          onFilter: onFilter,
          setInputReset: setInputReset,
          focusSelected: focusSelected,
          bindFocusInputFunc: bindFocusInputFunc // collapse={collapse}
          ,
          maxLength: maxLength,
          convertBr: convertBr
        })
      );
    }
  }, {
    key: "renderPlaceholder",
    value: function renderPlaceholder(empty) {
      var _this$props7 = this.props,
          focus = _this$props7.focus,
          onFilter = _this$props7.onFilter,
          filterText = _this$props7.filterText,
          multiple = _this$props7.multiple,
          innerTitle = _this$props7.innerTitle;

      if (focus && onFilter && empty) {
        return this.renderInput(multiple ? filterText : '');
      }

      return (
        /*#__PURE__*/
        React.createElement("span", {
          key: "placeholder",
          style: !empty ? {
            display: 'none'
          } : undefined,
          className: classnames(inputClass('placeholder'), selectClass('ellipsis'), innerTitle && inputTitleClass('hidable'))
        },
        /*#__PURE__*/
        React.createElement("span", null, this.props.placeholder), "\xA0")
      );
    }
  }, {
    key: "renderResult",
    value: function renderResult() {
      var _this2 = this;

      var _this$props8 = this.props,
          multiple = _this$props8.multiple,
          compressed = _this$props8.compressed,
          renderResult = _this$props8.renderResult,
          renderUnmatched = _this$props8.renderUnmatched,
          onFilter = _this$props8.onFilter,
          focus = _this$props8.focus,
          filterText = _this$props8.filterText,
          resultClassName = _this$props8.resultClassName,
          getResultByValue = _this$props8.getResultByValue;
      var values = this.props.values || [];

      if (multiple) {
        var items = values.map(function (n, i) {
          return _this2.renderItem(n, i);
        }).filter(function (n) {
          return !isEmpty(n);
        });

        if (compressed) {
          items = this.renderMore(items);
        }

        if (focus && onFilter) {
          items.push(this.renderInput(filterText, values.length));
        }

        return items;
      }

      var result0 = getResultByValue(values[0]);

      if (onFilter) {
        return this.renderInput(getResultContent(result0, renderResult, renderUnmatched));
      }

      var v = getResultContent(result0, renderResult, renderUnmatched);
      var title = isString(v) ? v : undefined;
      return (
        /*#__PURE__*/
        React.createElement("span", {
          key: "result",
          title: title,
          className: classnames(selectClass('ellipsis'), getResultClassName(resultClassName, result0))
        }, v)
      );
    }
  }, {
    key: "renderIndicator",
    value: function renderIndicator() {
      var _this$props9 = this.props,
          multiple = _this$props9.multiple,
          showArrow = _this$props9.showArrow,
          compressed = _this$props9.compressed;
      if (!showArrow || multiple && !compressed) return null;
      var showCaret = !multiple; // eslint-disable-next-line

      return (
        /*#__PURE__*/
        React.createElement("a", {
          key: "indicator",
          tabIndex: -1,
          className: selectClass('indicator', multiple ? 'multi' : 'caret')
        }, showCaret &&
        /*#__PURE__*/
        React.createElement(Caret, null))
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props10 = this.props,
          compressed = _this$props10.compressed,
          innerTitle = _this$props10.innerTitle,
          focus = _this$props10.focus,
          onFilter = _this$props10.onFilter;
      var showPlaceholder = this.isEmptyResult();
      var placeholder = this.renderPlaceholder(showPlaceholder);
      var result = showPlaceholder ? null : this.renderResult();
      var rtl = isRTL();
      var clearEl = this.renderClear();
      var indicator = this.renderIndicator();
      var inner = [result, placeholder, indicator, clearEl];
      var open = onFilter && focus || !showPlaceholder;
      return (
        /*#__PURE__*/
        React.createElement(InputTitle, {
          innerTitle: innerTitle,
          open: open,
          className: selectClass('title-box'),
          titleClass: selectClass(getDirectionClass('title-box-title'))
        },
        /*#__PURE__*/
        React.createElement("div", {
          ref: this.bindResult,
          className: classnames(selectClass(getDirectionClass('result'), compressed && 'compressed', showPlaceholder && 'empty', clearEl && 'result-clearable'), innerTitle && inputTitleClass(getDirectionClass('item'), 'item-scroll'))
        }, rtl ? inner.reverse() : inner))
      );
    }
  }]);

  return Result;
}(PureComponent);

export default Result;